import HeaderLogo from './code/Scripts/components/HeaderLogo.vue';

export default {
  components: {
    HeaderLogo,
  },
};
